import(/* webpackMode: "eager" */ "/learn-web/features/common/containers/FormProvider/FormProvider.tsx");
;
import(/* webpackMode: "eager" */ "/learn-web/features/faucet/containers/Page/Page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/learn-web/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/learn-web/node_modules/next-translate/lib/esm/AppDirI18nProvider.js");
